import { Directive, ElementRef, Input, OnChanges } from '@angular/core';
import DOMPurify from 'dompurify';
import { stripStyleComments } from 'src/app/shared/html-sanitize';

/**
 * Renders server-provided HTML (TOS / TAA documents) safely.
 *
 * The HTML is sanitized with DOMPurify (scripts, event handlers, javascript: URLs
 * etc. are removed) and the resulting DOM nodes are inserted directly into the
 * host element. Angular's DomSanitizer is never bypassed and no raw HTML string
 * is assigned to innerHTML.
 *
 * Usage: <div [appSanitizedHtml]="html"></div>
 */
@Directive({
  selector: '[appSanitizedHtml]',
  standalone: true,
})
export class SanitizedHtmlDirective implements OnChanges {
  /** Untrusted HTML to sanitize and render */
  @Input('appSanitizedHtml') html: string | null | undefined = '';

  constructor(private readonly _el: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    const fragment = DOMPurify.sanitize(stripStyleComments(this.html ?? ''), {
      FORCE_BODY: true, // keep leading <style> blocks
      RETURN_DOM_FRAGMENT: true,
    });
    this._el.nativeElement.replaceChildren(fragment);
  }
}
